module.exports = "/build/web/svg/account.75579a493a04f350d1452d82d7aa8a8c.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/account.svg
// module id = 141
// module chunks = 24